import { GlobalAxios } from "../axios/axios-config";
import { IPatientEncounterClassification } from "../models/patient-encounter-classification";

const PATIENT_ENCOUNTER_CLASSIFICATION_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/PatientEncounterClassification/PatientEncounterClassification";

export const patientEncounterClassificationList = (params?: any) => {
  return GlobalAxios.get<IPatientEncounterClassification[]>(
    PATIENT_ENCOUNTER_CLASSIFICATION_ROUTE,
    { params },
  );
};
